/********************************************************************
 * globals.js
 * Will be loaded in <head>. Useful for early required functionalities.
 */

import './mail'